const copyDebugId = (payload) => {
    const text = Object.entries(payload)
        .map(([k, v]) => `${k}=${v}`)
        .join(' ');
    if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(text);
    }
    // execCommand fallback for older browsers
    const el = document.createElement('textarea');
    el.value = text;
    el.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    return Promise.resolve();
};

export default copyDebugId;
